module.exports = __webpack_public_path__ + "static/pic03-f34f1ab3855f7751e146ad1dff401a7a.jpg";